import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Line } from 'react-chartjs-2';

function GraficaEficienciaPorMaquina({ machineData, maquina, fechaInicio, fechaFin }) {
  const isFechaValida = fechaInicio && fechaFin && fechaInicio <= fechaFin;

  // Filtrar lecturas por máquina y rango de fechas
  let lecturas = [];
  if (maquina && fechaInicio && fechaFin && Array.isArray(machineData)) {
    machineData.forEach(m => {
      if (Array.isArray(m.lecturas)) {
        m.lecturas.forEach(l => {
          const id = l.maquinaId || l.maquina || m.maquinaId;
          if (id === maquina) {
            const fechaDato = new Date(l.fecha);
            const fechaStr = fechaDato.getFullYear() + '-' + String(fechaDato.getMonth()+1).padStart(2,'0') + '-' + String(fechaDato.getDate()).padStart(2,'0');
            if (fechaStr >= fechaInicio && fechaStr <= fechaFin) lecturas.push(l);
          }
        });
      }
    });
  }

  // Agrupar lecturas por día y promediar eficiencia
  let labels = [];
  let promedios = [];
  let data = null;
  if (lecturas.length > 0) {
    const eficienciaPorDia = {};
    lecturas.forEach(l => {
      const fechaObj = new Date(l.fecha);
      const dia = fechaObj.getFullYear() + '-' + String(fechaObj.getMonth()+1).padStart(2,'0') + '-' + String(fechaObj.getDate()).padStart(2,'0');
      if (!eficienciaPorDia[dia]) eficienciaPorDia[dia] = [];
      eficienciaPorDia[dia].push(Number(l.eficiencia || 0));
    });
    labels = Object.keys(eficienciaPorDia).sort();
    promedios = labels.map(dia => {
      const arr = eficienciaPorDia[dia];
      if (arr.length === 0) return 0;
      return arr.reduce((a, b) => a + b, 0) / arr.length;
    });
    data = {
      labels,
      datasets: [
        {
          label: 'Eficiencia promedio',
          data: promedios,
          borderColor: 'rgba(249,167,55,1)',
          backgroundColor: 'rgba(249,167,55,0.2)',
          borderWidth: 1, // línea más delgada
          tension: 0.7, // curva más acentuada
          pointRadius: 3,
        },
      ],
    };
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Eficiencia por día (${maquina || 'Seleccione máquina'})` },
    },
    scales: {
      x: {
        title: { display: true, text: 'Día' },
        ticks: {
          callback: (val, idx) => labels[idx] || '',
          font: { size: 10 },
          maxTicksLimit: 28,
          autoSkip: true,
          stepSize: 1,
        },
        grid: {
          lineWidth: 0.5,
          drawTicks: true,
        },
        offset: false,
      },
      y: { title: { display: true, text: 'Eficiencia (%)' }, min: 0, max: 100 },
    },
  };

  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Gráfica de eficiencia por máquina
      </Typography>
      <Box sx={{ height: 350, overflowX: 'auto', width: '100%' }}>
        {!maquina || !fechaInicio || !fechaFin ? (
          <Typography color="textSecondary" sx={{ mt: 8, textAlign: 'center' }}>
            Selecciona máquina y rango de fechas para ver la gráfica
          </Typography>
        ) : !isFechaValida ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            La fecha inicial debe ser menor o igual a la fecha final
          </Typography>
        ) : labels.length === 0 ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            No hay datos para el rango seleccionado
          </Typography>
        ) : (
          <Box sx={{ minWidth: 600, maxWidth: '100%' }}>
            <Line data={data} options={options} />
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default GraficaEficienciaPorMaquina;